import type { SVGProps } from "react";
export interface HillRockslideIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function HillRockslideIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: HillRockslideIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M19.782 8.38c.335-.081.692-.003.966.216l1.958 1.568c.314.251.47.652.409 1.05l-.383 2.471a1.13 1.13 0 0 1-.707.877l-2.34.903a1.13 1.13 0 0 1-1.108-.171l-1.959-1.57a1.13 1.13 0 0 1-.409-1.05l.383-2.47.034-.146c.098-.332.345-.604.673-.73l2.341-.903.142-.046Zm-1.068 2.812-.183 1.182.947.759 1.129-.435.184-1.185-.946-.758-1.13.437Zm-4.573-3.47a1.374 1.374 0 1 1-1.509 1.507l-.007-.14.007-.141a1.375 1.375 0 0 1 1.369-1.234zM10 3.254l.15.01c.343.046.65.25.826.555l.5.87c.198.347.198.774 0 1.121l-.5.87c-.201.35-.573.564-.976.564H9c-.403 0-.775-.215-.976-.564l-.5-.87a1.13 1.13 0 0 1 0-1.12l.5-.87.083-.125c.211-.275.54-.44.893-.441zm8.14.378a1.375 1.375 0 1 1-1.507 1.509L16.625 5l.008-.14A1.375 1.375 0 0 1 18 3.624zM5.141.882a1.375 1.375 0 1 1-1.509 1.51l-.007-.142.007-.14A1.375 1.375 0 0 1 5 .875zM.875 9.121c0-2.201 2.545-3.424 4.264-2.05l14.225 11.38c1.937 1.55.84 4.674-1.64 4.674H5A4.125 4.125 0 0 1 .875 19zM3.125 19c0 1.035.84 1.875 1.875 1.875h12.724a.375.375 0 0 0 .234-.668L3.734 8.828a.375.375 0 0 0-.609.293z"
      />
    </svg>
  );
}
